import * as styles from "./PageHeader.css";

import { clsx } from "clsx";
import type { JSX } from "react";

import { Button } from "@frontend/components/atoms/Button";
import { Icon } from "@frontend/components/atoms/Icon";
import {
  Menu,
  MenuContent,
  MenuTrigger,
} from "@frontend/components/atoms/Menu";
import {
  FloatingPortalContainerProvider,
  useIslandPortalContainer,
} from "@frontend/contexts";
import { useLingui } from "@lingui/react/macro";

import type { PageHeaderActionsProps } from "./PageHeader.types";
import { usePageHeaderActionsFit } from "./usePageHeaderActionsFit";

export function PageHeaderActions({
  menuLabel,
  children,
  className,
}: PageHeaderActionsProps): JSX.Element {
  const { t } = useLingui();
  const { rowRef, collapsed } = usePageHeaderActionsFit();
  const island = useIslandPortalContainer();

  return (
    <div
      ref={rowRef}
      data-slot="page-header-actions"
      data-collapsed={collapsed || undefined}
      className={clsx(styles.actions, className)}
    >
      {collapsed ? (
        <FloatingPortalContainerProvider value={island}>
          <Menu>
            <MenuTrigger
              render={(triggerProps) => (
                <Button
                  {...triggerProps}
                  size="sm"
                  variant="ghost"
                  aria-label={menuLabel ?? t`Actions`}
                >
                  <Icon name="EllipsisVertical" size="sm" />
                </Button>
              )}
            />

            <MenuContent className={styles.overflow}>{children}</MenuContent>
          </Menu>
        </FloatingPortalContainerProvider>
      ) : (
        children
      )}
    </div>
  );
}
